import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { RoutingService } from '../../services/routing/routing.service';

@Injectable()
export class AuthGuard {
  constructor(
    private _authService: AuthService,
    private _routingService: RoutingService,
  ) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this._authService.IsAuthenticated()) {
      this._routingService.goToLogin();
      return false;
    }
    return true;
  }
}

@Injectable()
export class AuthGuardStaff {
  constructor(
    private _authService: AuthService,
    private _routingService: RoutingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this._authService.isGuest()) {
      this._routingService.goToLogin(state.url);
      return false;
    } else {
      return this._authService.isStaff();
    }
  }
}

@Injectable()
export class AuthGuardStaffPatron {
  constructor(
    private _authService: AuthService,
    private _routingService: RoutingService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this._authService.isStaff() || this._authService.isPatron()) {
      return true;
    } else {
      this._routingService.goToLogin(state.url);
      return false;
    }
  }
}
